/** Web 商品运营 API；与原生 metadata/Adapty 数据完全独立。 */
import type {
  CreateWebPaymentProductRequest,
  UpdateWebPaymentProductRequest,
  WebPaymentProductResponse,
  WebProductDevicePlatform,
  WebProductVariantRequest,
} from '@novel-admin/shared';
import { apiRequest, apiRequestOffsetPaged } from '~/api/client';

export const webPaymentProductsApi = {
  list: (
    appId: string,
    query: {
      page: number;
      limit: number;
      search?: string;
      product_type?: 'CONSUMABLE' | 'SUBSCRIPTION';
    },
  ) =>
    apiRequestOffsetPaged<WebPaymentProductResponse>({
      method: 'GET',
      path: `/api/v1/apps/${appId}/web-payment-products`,
      query,
    }),
  create: (appId: string, body: CreateWebPaymentProductRequest) =>
    apiRequest<WebPaymentProductResponse>({
      method: 'POST',
      path: `/api/v1/apps/${appId}/web-payment-products`,
      body,
    }),
  update: (id: string, body: UpdateWebPaymentProductRequest) =>
    apiRequest<WebPaymentProductResponse>({
      method: 'PATCH',
      path: `/api/v1/web-payment-products/${id}`,
      body,
    }),
  replaceVariant: (id: string, device: WebProductDevicePlatform, body: WebProductVariantRequest) =>
    apiRequest<WebPaymentProductResponse>({
      method: 'PUT',
      path: `/api/v1/web-payment-products/${id}/variants/${device}`,
      body,
    }),
  removeVariant: (id: string, device: 'IOS' | 'ANDROID') =>
    apiRequest<{ id: string; deleted_at: string }>({
      method: 'DELETE',
      path: `/api/v1/web-payment-products/${id}/variants/${device}`,
    }),
  remove: (id: string) =>
    apiRequest<{ id: string; deleted_at: string }>({
      method: 'DELETE',
      path: `/api/v1/web-payment-products/${id}`,
    }),
};
